import React, { MouseEvent } from 'react';

const Button = ({ children, onClick, disabled, type, className, flipped }: {
    children: React.ReactNode
    onClick?: (e: MouseEvent) => void,
    disabled?: boolean,
    type?: "button" | "submit" | "reset" | undefined,
    className?: string,
    flipped?: boolean
}) => {

    const bg = flipped
        ? 'bg-back-blue'
        : 'bg-mid-blue';
    return (
        <button
            className={`block w-fit pl-3 pr-3 p-2 rounded-md ${bg} hover:bg-gray-500 ${className ?? ''}`}
            type={type}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};
export default Button;
